import { labelsMapToOptions } from "../object/labelsMapToOptions";

export enum ResidencePermit {
  RESIDENCE_FRENCH_CNI = "residenceFrenchCNI",
  RESIDENCE_UE_CNI = "residenceUECNI",
  RESIDENCE_TS_RESIDENT = "residenceTSResident",
  RESIDENCE_TS = "residenceTS",
  RESIDENCE_PROTECTION = "residenceProtection",
  RESIDENCE_REFUGEE = "residenceRefugee",
  RESIDENCE_BPI = "residenceBPI",
  RESIDENCE_BPT = "residenceBPT",
  RESIDENCE_ASYLUM_SEEKER_WITH_WORK_AUTH = "demandeur_d'asile_avec_autorisation_de_travail",
  RESIDENCE_RECEIPT_WITH_WORK_AUTH = "recepisse_de_demande_de_titre_de_sejour_avec_autorisation_de_travail",
}

export enum Nationality {
  NATIONALITY_FRENCH = "nationalityFrench",
  NATIONALITY_EU = "nationalityEU",
  NATIONALITY_OUT_EU = "nationalityOutEU",
}

export enum MaritalStatus {
  MARRIED_SITUATION_UNKNOWN = "MarriedSituationUnknown",
  MARRIED_SITUATION_SINGLE = "MarriedSituationSingle",
  MARRIED_SITUATION_COUPLE = "MarriedSituationCouple",
  MARRIED_SITUATION_MARRIED = "MarriedSituationMarried",
  MARRIED_SITUATION_DIVORCED = "MarriedSituationDivorced",
  MARRIED_SITUATION_WIDOW = "MarriedSituationWidow",
  MARRIED_SITUATION_SEPARATED = "MarriedSituationSeparated",
  MARRIED_SITUATION_PACS = "MarriedSituationPacs",
  MARRIED_SITUATION_COHABITATION = "MarriedSituationCohabitation",
}

export enum PESituation {
  PE_SITUATION_NO_INFO = "peSituationNoInfo",
  PE_SITUATION_REGISTERED = "peSituationRegistered",
  PE_SITUATION_STOPPED = "peSituationStopped",
  PE_SITUATION_BANNED = "peSituationBanned",
  PE_SITUATION_UNKNOWN = "peSituationUnknown",
  PE_SITUATION_NOT_REGISTERED = "peSituationNotRegistered",
  PE_SITUATION_PENDING = "peSituationPending",
}

export enum Gender {
  WOMAN = "F",
  MAN = "M",
}

export const GENDER_LABELS: Record<Gender, string> = {
  [Gender.WOMAN]: "Madame",
  [Gender.MAN]: "Monsieur",
};

export const GENDER_FILTER_OPTIONS = labelsMapToOptions(GENDER_LABELS);

export const RESIDENCE_PERMIT_LABELS: Record<ResidencePermit, string> = {
  [ResidencePermit.RESIDENCE_FRENCH_CNI]: "CNI française",
  [ResidencePermit.RESIDENCE_UE_CNI]: "CNI européenne",
  [ResidencePermit.RESIDENCE_TS_RESIDENT]: "Titre de séjour résident",
  [ResidencePermit.RESIDENCE_TS]: "Titre de séjour",
  [ResidencePermit.RESIDENCE_PROTECTION]: "Protection subsidiaire",
  [ResidencePermit.RESIDENCE_REFUGEE]: "Personne réfugiée",
  [ResidencePermit.RESIDENCE_BPI]: "BPI",
  [ResidencePermit.RESIDENCE_BPT]: "BPT",
  [ResidencePermit.RESIDENCE_ASYLUM_SEEKER_WITH_WORK_AUTH]: "Demandeur d'asile avec autorisation de travail",
  [ResidencePermit.RESIDENCE_RECEIPT_WITH_WORK_AUTH]:
    "Récépissé de demande de titre de séjour avec autorisation de travail",
};

export const NATIONALITY_LABELS: Record<Nationality, string> = {
  [Nationality.NATIONALITY_FRENCH]: "Française",
  [Nationality.NATIONALITY_EU]: "UE",
  [Nationality.NATIONALITY_OUT_EU]: "Hors UE",
};

export const MARITAL_STATUS_LABELS: Record<MaritalStatus, string> = {
  [MaritalStatus.MARRIED_SITUATION_UNKNOWN]: "Inconnue",
  [MaritalStatus.MARRIED_SITUATION_SINGLE]: "Célibataire",
  [MaritalStatus.MARRIED_SITUATION_COUPLE]: "En couple",
  [MaritalStatus.MARRIED_SITUATION_MARRIED]: "Marié(e)",
  [MaritalStatus.MARRIED_SITUATION_DIVORCED]: "Divorcé(e)",
  [MaritalStatus.MARRIED_SITUATION_WIDOW]: "Veuf(ve)",
  [MaritalStatus.MARRIED_SITUATION_SEPARATED]: "Séparé(e)",
  [MaritalStatus.MARRIED_SITUATION_PACS]: "Pacsé(e)",
  [MaritalStatus.MARRIED_SITUATION_COHABITATION]: "Concubinage",
};

export const PE_SITUATION_LABELS: Record<PESituation, string> = {
  [PESituation.PE_SITUATION_NO_INFO]: "Non renseigné",
  [PESituation.PE_SITUATION_REGISTERED]: "Inscrit(e)",
  [PESituation.PE_SITUATION_STOPPED]: "Cessation",
  [PESituation.PE_SITUATION_BANNED]: "Radiation",
  [PESituation.PE_SITUATION_UNKNOWN]: "Non connu",
  [PESituation.PE_SITUATION_NOT_REGISTERED]: "Non inscrit(e)",
  [PESituation.PE_SITUATION_PENDING]: "En cours / En transfert",
};
